import { getGuestCartProducts } from 'modules/Cart/actions';
import { stringify } from 'qs';
import { SERVER_URL } from 'constants/index';
import * as actions from './actions';

const addProductToCart = (cartId, productSku) => dispatch => {
    let queryAddToCart = {
        cartItem: {
            quote_id: `${cartId}`,
            sku: `${productSku}`,
            qty: 1
        }
    };

    dispatch(actions.triggerMinicartAnimation(false));

    queryAddToCart = stringify(queryAddToCart);

    fetch(SERVER_URL + `guest-carts/${cartId}/items?${queryAddToCart}`, {
        method: 'POST'
    })
        .then(reponse => reponse.json())
        .then(json => {
            dispatch(actions.addProductToCart());
            dispatch(getGuestCartProducts(cartId));
            dispatch(actions.triggerMinicartAnimation(true));
        });
};

const removeProductFromCart = (cartId, cartItemId) => dispatch => {
    dispatch(actions.triggerCartLoading(true));

    fetch(`${SERVER_URL}guest-carts/${cartId}/items/${cartItemId}`, {
        method: 'DELETE'
    })
        .then(response => response.json())
        .then(json => {
            actions.removeProductFromCart();
            dispatch(getGuestCartProducts(cartId));
            dispatch(actions.triggerCartLoading(false));
        })
        .catch(error => console.error(error));
};

export { addProductToCart, removeProductFromCart };



// WEBPACK FOOTER //
// ./src/components/ProductItem/actions/operations.js